// import LogoTemplate from "./Template";
import LogoTemplate from './Template2';

export const DarkModeLogo = () => <LogoTemplate fillColor="#A5A5A5" />;
export const LightModeLogo = () => <LogoTemplate fillColor="#303030" />;
